// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddBranchModal_modal__1O3i2","input":"AddBranchModal_input__3talc","modalBody":"AddBranchModal_modalBody__2Ex5d","addMore":"AddBranchModal_addMore__ArPId"};